module.exports = __webpack_public_path__ + "static/media/qr-code.95f74656.png";